export const renderValueStockUnit = (qtyPerUnit: string | null) => {
  return qtyPerUnit || "-";
};

// export const renderValueStockUnit = (
//   qtyPerUnit: string | null,
//   unit: string | null
// ) => {
//   console.log("qtyPerUnit", qtyPerUnit);
//   console.log("unit", unit);

//   return qtyPerUnit && unit
//     ? `${qtyPerUnit} ${unit}`
//     : qtyPerUnit || unit || "-";
// };

export const renderLabelWholeSale = (
  min: number | null,
  max: number | null,
  unit: string
) => {
  if (min && max) {
    return `${min} ${max} ${unit}`;
  }
  if (min && !max) {
    return `${min} ${unit || ""} ขึ้นไป`;
  }
};
